import { useTypedSelector } from 'state';
import { useEffect } from 'react';
import { TenantConfig } from './tenantConfigTypes';
import { useDispatch } from 'react-redux';
import { fetchTenantConfig } from './tenantConfigActions';

export interface TenantConfigLoaderProps {
  adminConfig?: TenantConfig;
  moderatorConfig?: TenantConfig;
}

export function TenantConfigLoader(props: TenantConfigLoaderProps) {
  const { adminConfig, moderatorConfig } = props;

  const isRegistered = useTypedSelector(state => state.currentUser.isRegistered);
  const spotId = useTypedSelector(state => state.application.spotId);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isRegistered && spotId) {
      if (adminConfig) {
        dispatch(fetchTenantConfig({ defaultConfig: adminConfig, spotId, type: 'admin' }));
      }

      if (moderatorConfig) {
        dispatch(fetchTenantConfig({ defaultConfig: moderatorConfig, spotId, type: 'moderator' }));
      }
    }
  }, [isRegistered, spotId, moderatorConfig, adminConfig, dispatch]);

  return null;
}
